import React, { useState } from 'react';
import { BlockWrapper } from '../../common/BlockWrapper';
import './Facilities.scss';
import FacilitiesApproval from './FacilitiesApproval';
import FacilitiesForm from './FacilitiesForm';
import FacilitiesView from './FacilitiesView';
import RaisedButton from 'material-ui/RaisedButton';
import PropTypes from 'prop-types';
import { hasChanges } from '../../common/utils';
import get from 'lodash/get';

const Facilities = ({
    port,
    pendingChanges,
    onApproveField,
    onRejectField,
    updatePortField,
}) => {
    const [isEditing, setIsEditing] = useState(false);

    const saveChanges = async (change) => {
        updatePortField('facilities', change, () => {
            setIsEditing(false);
        });
    };

    const processedStatus = get(pendingChanges, 'processedFields.facilities.status');

    const isApproved = processedStatus === 'approved';
    const isRejected = processedStatus === 'rejected';

    if (
        !isApproved &&
        !isRejected &&
        hasChanges(
            get(pendingChanges, 'originalValues.facilities'), 
            get(pendingChanges, 'changedValues.facilities'),
        )
    ) {
        return (
            <BlockWrapper title='Facilities'>
                <FacilitiesApproval 
                    originalValues={pendingChanges.originalValues.facilities}
                    changedValues={pendingChanges.changedValues.facilities}
                    onApprove={onApproveField}
                    onReject={onRejectField}
                />
            </BlockWrapper>
        );
    }

    return (
        <BlockWrapper title='Facilities'>
            {isEditing ? (
                <FacilitiesForm 
                    initialValues={port.facilities}
                    onSubmit={values => saveChanges(values)}
                    onCancel={() => setIsEditing(false)}
                />
            ) : (
                <React.Fragment>
                    <FacilitiesView values={port.facilities} />
                    <div className='edit-actions'>
                        <RaisedButton
                            label='Edit Facilities'
                            onClick={() => setIsEditing(true)}
                            primary
                        />
                    </div>
                </React.Fragment>
            )}
        </BlockWrapper>
    );
};

Facilities.propTypes = {
    port: PropTypes.shape({
        facilities: PropTypes.object,
    }).isRequired,
    pendingChanges: PropTypes.shape({
        originalValues: PropTypes.shape({
            facilities: PropTypes.object,
        }),
        changedValues: PropTypes.shape({
            facilities: PropTypes.object,
        }),
        processedFields: PropTypes.object,
    }),
    onApproveField: PropTypes.func.isRequired,
    onRejectField: PropTypes.func.isRequired,
    onSaveChanges: PropTypes.func.isRequired,
};

export default Facilities;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/Facilities/Facilities.jsx